<template>
    <v-toolbar
            fixed
            dark
            class="primary"
            ref="main-toolbar"
    >
        <v-btn
                icon
                @click="back()"
        >
            <v-icon>
                arrow_back
            </v-icon>
        </v-btn>
        <v-toolbar-title v-text="$store.state.nav.title" style="position: relative" class="d-flex"></v-toolbar-title>
    </v-toolbar>
</template>

<script>
    export default {
        name: 'MainToolbar',
        computed: {
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// MainToolbar.vue?7b2f74ec